export default __webpack_public_path__ + "static/media/loadingicon.c543e020.png";